import { types } from '../types/auth'
import { authToken } from '../services/auth'
import { IAuth, AuthActionsType } from '../types/auth'

export const initialState: IAuth = {
  token: authToken.get(),
  rights: {
    raw: [],
    parsed: [],
  },
  permissions: {
    isSystemAdmin: false,
    isSystemApprover: false,
    isSystemSupport: false,
    editorForGroups: [],
    restrictedAreasReadable: [],
    restrictedAreasWritable: [],
  },
}

export const auth = (state = initialState, action: AuthActionsType): IAuth => {
  switch (action.type) {
    case types.PUT_CREDENTIALS:
      return { ...state, ...action.credentials }
    default:
      return state
  }
}
